<svg
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 548.291 548.291"
  style="enable-background: new 0 0 548.291 548.291"
  xml:space="preserve"
>
  <g>
    <path
      d="M261.182,297.106c0,26.18,12.292,44.62,32.522,44.62c20.438,0,32.132-19.428,32.132-45.407
		c0-23.985-11.501-44.617-32.329-44.617C273.088,251.702,261.182,271.141,261.182,297.106z"
    />
    <path
      d="M486.201,196.121h-13.166v-63.525c0-0.399-0.062-0.795-0.115-1.2c-0.021-2.522-0.825-5-2.552-6.96L364.657,3.675
		c-0.033-0.031-0.064-0.042-0.085-0.073c-0.63-0.704-1.364-1.292-2.143-1.796c-0.229-0.157-0.461-0.286-0.702-0.419
		c-0.672-0.365-1.387-0.672-2.121-0.893c-0.2-0.052-0.379-0.134-0.577-0.188C358.23,0.118,357.401,0,356.562,0H96.757
		C84.894,0,75.256,9.649,75.256,21.502v174.613H62.092c-16.971,0-30.732,13.756-30.732,30.73v159.81
		c0,16.966,13.761,30.736,30.732,30.736h13.164V526.79c0,11.854,9.638,21.501,21.501,21.501h354.776
		c11.853,0,21.501-9.647,21.501-21.501V417.392h13.166c16.966,0,30.729-13.764,30.729-30.731v-159.81
		C516.93,209.877,503.167,196.121,486.201,196.121z M96.757,21.507h249.054v110.006c0,5.94,4.817,10.751,10.751,10.751h94.972
		v53.861H96.757V21.507z M357.757,295.322c0,43.833-26.572,70.405-65.627,70.405c-39.673,0-62.868-29.948-62.868-68.011
		c0-40.069,25.576-70.004,65.036-70.004C335.343,227.707,357.757,258.451,357.757,295.322z M94.986,312.771l-2.378,50.771H64.652
		l8.53-133.646h40.245l13.095,44.606c4.16,15.475,8.328,32.137,11.299,47.802h0.59c3.774-15.471,8.345-33.119,12.694-47.99
		l14.281-44.418h39.462l7.336,133.646H182.64l-1.987-51.159c-0.593-16.064-1.194-35.503-1.194-54.934h-0.591
		c-4.163,17.053-9.724,36.108-14.864,51.773l-16.259,52.146h-23.604l-14.278-51.77c-4.37-15.665-8.932-34.698-12.1-52.15h-0.396
		C96.576,275.495,95.978,296.125,94.986,312.771z M451.534,520.968H96.757V417.392h354.776V520.968z M443.05,363.542h-35.298
		l-42.834-133.646h33.113l16.257,56.513c4.562,15.862,8.724,31.14,11.9,47.8h0.599c3.371-16.062,7.528-31.938,12.095-47.207
		l17.051-57.1h32.137L443.05,363.542z"
    />
  </g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
</svg>
